// @ts-nocheck
import {
  createI18n,
  I18nOptions,
  LocaleMessages,
  VueMessageType,
} from "vue-i18n";
import en from "./locales/en.json";
import da from "./locales/da.json";
import sv from "./locales/sv.json";
import nb from "./locales/nb.json";
import nn from "./locales/nn.json";
/* https://www.codeandweb.com/babeledit/tutorials/how-to-translate-your-vue-app-with-vue-i18n
 *
 */

// we build a main file with the default locale, the other languages are loaded later
const defaultLocale = import.meta.env.VUE_APP_I18N_LOCALE || "da";

const savedLocale =
  typeof localStorage !== "undefined" ? localStorage.getItem("locale") : null;

// load our language chunk and set our language after request
// will refresh the views with the new language immediately

export const SUPPORT_LOCALES = ["da", "en", "sv", "nb", "nn"];

const numberFormats = {
  en: {
    currency: {
      style: "currency",
      currency: "USD",
    },
    percent: {
      style: "percent",
    },
    decimal: {
      style: "decimal",
    },
  },
  da: {
    currency: {
      style: "currency",
      currency: "DKK",
    },
    percent: {
      style: "percent",
    },
    decimal: {
      style: "decimal",
    },
  },
  nb: {
    currency: {
      style: "currency",
      currency: "NOK",
    },
    percent: {
      style: "percent",
    },
    decimal: {
      style: "decimal",
    },
  },
  nn: {
    currency: {
      style: "currency",
      currency: "NOK",
    },
    percent: {
      style: "percent",
    },
    decimal: {
      style: "decimal",
    },
  },
};

const SUPPORT_LOCALES_SET = new Set(["da", "en", "sv", "nb", "nn"]);
const initialLocale =
  savedLocale && SUPPORT_LOCALES_SET.has(savedLocale)
    ? savedLocale
    : SUPPORT_LOCALES_SET.has(defaultLocale)
      ? defaultLocale
      : "da";

const defaultConfig: I18nOptions = {
  locale: initialLocale,
  legacy: false,
  fallbackLocale: defaultLocale,
  messages: { da: da, en: en, sv: sv, nb: nb, nn: nn },
  globalInjection: true,
  numberFormats: numberFormats,
  silentTranslationWarn: process.env.NODE_ENV === "test",
  warnHtmlInMessage: "off",
};

const i18n = createI18n(defaultConfig);
export default i18n;

export function loadLocaleMessages(): any {
  const locales = require.context(
    "./locales",
    true,
    /[A-Za-z0-9-_,\s]+\.json$/i,
  );
  const messages: LocaleMessages<VueMessageType> = {};
  locales.keys().forEach((key) => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = locales(key).default;
    }
  });
  return messages;
}
